<div class="wrap">
  <div class="header">
      <div class="title">
          <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active" appChangeColorTheme attribute="color"></fa-icon>
          <h2>Liste des acteurs</h2>
      </div>

      <div class="add_search_club">
          <div class="add_club" (click)="openDialogAddClub('new')" appChangeColorTheme [isHover]="true">
              <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
              <span>Ajouter un acteur</span>
          </div>
          <div class="search_bar">
              <form [formGroup]="searchForm">
                  <input type="text" placeholder="Chercher un acteur ..." (input)="applyFilter($event.target.value)"
                      formControlName="keyword">

              </form>

              <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput" ></fa-icon>
              <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput" ></fa-icon>

          </div>
      </div>
  </div>

  <div class="content" [hidden]="isLoading">
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

          <ng-container matColumnDef="clubCode">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="clubCode" class="cell_code_club"> Code
              </th>
              <td mat-cell *matCellDef="let element" class="cell_code_club"> {{element.clubCode}} </td>
          </ng-container>

          <ng-container matColumnDef="logo">
              <th mat-header-cell *matHeaderCellDef  class="cell_club">Image</th>
              <td mat-cell *matCellDef="let element" class="cell_club" [style.padding.px]="5">
                  <img [src]="getLogoClub(element.logoBase64)" [style.width.px]="50" [style.height.%]="100" alt="logo_club">
            </td>
          </ng-container>

          <ng-container matColumnDef="clubName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="clubName" class="cell_club">Nom de l'acteur</th>
              <td mat-cell *matCellDef="let element" class="cell_club"> {{element.clubName}} </td>
          </ng-container>

          <ng-container matColumnDef="isNetworkHead">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="isNetworkHead" class="cell_club">Tête de réseau</th>
              <td mat-cell *matCellDef="let element" class="cell_club"> {{element.isNetworkHead ? 'Oui' : 'Non'}} </td>
          </ng-container>

          <!-- <ng-container matColumnDef="federation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="federation" class="cell_club">Tête de réseau </th>
            <td mat-cell *matCellDef="let element" class="cell_club">
              <ul class="federationList" *ngIf="element?.federation?.length > 0">
                <li *ngFor="let federation of element.federation">{{federation.label}}</li>
              </ul>
            </td>
          </ng-container> -->

          <ng-container matColumnDef="details">
              <th mat-header-cell *matHeaderCellDef class="cell_action"> Détails </th>
              <td mat-cell *matCellDef="let element" class="cell_action">
                  <fa-icon [icon]="getFaIcon('faInfoCircle')" [routerLink]="['/admin/club-details']"
                      [queryParams]="{clubCode: element.clubCode}" [matTooltip]="getTooltip('detailsClub')+ ': ' + element.clubName" appChangeColorTheme attribute="color" ></fa-icon>
              </td>
          </ng-container>

          <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef class="cell_action"> Editer </th>
              <td mat-cell *matCellDef="let element" class="cell_action">
                  <fa-icon [icon]="getFaIcon('faPen')" appChangeColorTheme attribute="color"
                      (click)="openDialogAddClub('update', element)">
                  </fa-icon>
              </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;">
          </tr>
      </table>
      <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          (page)="pageEvent = $event" [color]="color">
      </mat-paginator>
  </div>
  <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>
</div>
